/**
 * SaleDetailContainer
 * --
 */
import React from 'react';
import SaleDetailPresenter from './SaleDetailPresenter';

const SaleDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SaleDetailPresenter />
    </>
  );
};

export default SaleDetailContainer;
